import React, {useEffect, useState} from "react";
import {isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import PhoneInput from "react-phone-number-input";
import QRCode from "react-qr-code";
import * as EmailValidator from "email-validator";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Row,
} from "reactstrap";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import {useDisclosure} from "../../hooks/useDisclosure";
import VerifyMobileModal from "./verifyMobileModal";
import {getUserProfile, getUsersResources} from "../../redux/Selectors/users.selector";
import {getOrgAddress, getOrganization} from "../../redux/Selectors/general.selectors";
import {getOrganizationAddress} from "../../redux/Actions/general.actions";
import {
  requestUserProfile,
  requestUserResources,
  sendEditUserModalData,
} from "../../redux/Actions/users.action";
import Config from "../../constants/enumConfig";
import "./profile.scss";

const Profile = () => {
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const {isOpen, onOpen, onClose} = useDisclosure();

  useEffect(() => {
    dispatch(requestUserResources());
    dispatch(getOrganizationAddress());
  }, [dispatch]);

  const baseURL = `${window.location.origin}${Config.production}`;

  const userDetails = useSelector(getUserProfile);
  const resources = useSelector(getUsersResources);
  const organizationDetails = useSelector(getOrganization);
  const organizationAddress = useSelector(getOrgAddress);
  const {street_address1, city, state, country} = organizationAddress;

  const {profile = {}} = userDetails;
  const {job_title = ""} = profile;

  const initialState = {...userDetails, phone_number: profile.phone_number};
  const [profileData, setProfile] = useState(initialState);
  const {
    first_name = "",
    last_name = "",
    username = "",
    email,
    phone_number,
    date_joined,
    last_login,
  } = profileData;

  let fullName = `${first_name} ${last_name}`;

  if (fullName === " ") {
    if (username === "") {
      fullName = email;
    } else {
      fullName = username;
    }
  }

  const handleOnChange = (e, name) => {
    let updateDate = {...profileData};

    updateDate = Object.assign({}, updateDate, {
      [name]: e?.target?.value,
    });

    setProfile(updateDate);
  };

  const handleSave = () => {
    setSubmitted(true);
    if (!isEmpty(email)) {
      const callback = (responseData) => {
        if (responseData?.data?.verified === false) {
          onOpen();
        } else {
          dispatch(requestUserProfile());
        }
      };
      dispatch(sendEditUserModalData(profileData, callback));
    } else {
      toast.error("Email cannot be empty");
    }
  };

  return (
    <SafeView>
      <VerifyMobileModal
        email={email}
        isOpen={isOpen}
        onCancel={onClose}
        phoneNumber={phone_number}
      />
      <CommonHeader
        content={"Save Changes"}
        handleAddClick={handleSave}
        testID={"submit-btn"}
      />
      <div className="profile-details-container">
        <Row>
          <Col className="order-xl-2 mb-3 mb-xl-0" xl="4">
            <Card className="card-profile shadow">
              <CardBody className="pt-4">
                <Row className="justify-content-center">
                  <div className="col">
                    <div className="d-flex justify-content-center" data-cy={"qr-code"}>
                      <QRCode value={baseURL} size={150} />
                    </div>
                    <div className="card-profile-stats d-flex justify-content-center mt-md-5">
                      <div>
                        <span className="heading">{resources?.sites}</span>
                        <span className="description">Sites</span>
                      </div>
                      <div>
                        <span className="heading">{resources?.locations}</span>
                        <span className="description">Locations</span>
                      </div>
                      <div>
                        <span className="heading">{resources?.systems}</span>
                        <span className="description">Systems</span>
                      </div>
                    </div>
                  </div>
                </Row>
                <div className="text-center">
                  <h3 data-cy={"full_name"}>{fullName}</h3>
                  <div className="h5 font-weight-300">{job_title}</div>
                  <div className="text-center">{organizationDetails?.name}</div>
                  <hr className="my-4" />
                  <p className="text-center" data-cy={"organization-address"}>{`${
                    street_address1 ? `${street_address1}, ` : ""
                  }${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${
                    country ? `${country}` : ""
                  }`}</p>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col className="order-xl-1" xl="8">
            <Card className="bg-secondary shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">My account</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">User information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-date-joined"
                          >
                            Date joined
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-date-joined"
                            placeholder="Date joined"
                            type="text"
                            value={date_joined}
                            disabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-last-login"
                          >
                            Last login
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-last-login"
                            placeholder="Last login"
                            type="text"
                            value={last_login}
                            disabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-username">
                            Username
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="lucky.jesse"
                            id="input-username"
                            placeholder="Username"
                            type="text"
                            value={username}
                            onChange={(e) => handleOnChange(e, "username")}
                            disabled={true}
                            data-cy={"username"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-email">
                            Email address
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-email"
                            placeholder="johndoe@example.com"
                            type="email"
                            value={email}
                            onChange={(e) => handleOnChange(e, "email")}
                            data-cy={"email"}
                            invalid={
                              (isEmpty(email) || !EmailValidator.validate(email)) &&
                              submitted
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            First name
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="Lucky"
                            id="input-first-name"
                            placeholder="First name"
                            type="text"
                            value={first_name}
                            onChange={(e) => handleOnChange(e, "first_name")}
                            data-cy={"first_name"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-last-name">
                            Last name
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue="Jesse"
                            id="input-last-name"
                            placeholder="Last name"
                            type="text"
                            value={last_name}
                            onChange={(e) => handleOnChange(e, "last_name")}
                            data-cy={"last_name"}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-last-name">
                            Mobile number with country code
                          </label>
                          <PhoneInput
                            style={{}}
                            placeholder="e.g. +1 1234567890"
                            value={phone_number}
                            onChange={(value) =>
                              handleOnChange({target: {value}}, "phone_number")
                            }
                          />
                          <FormText>Select country and enter mobile number</FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </SafeView>
  );
};

export default Profile;
